var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8NepalCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.989,
    cy: 24,
    r: 20,
    fill: "#eceff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M3.989,24c0,11.046,8.954,20,20,20c4.665,0,8.947-1.611,12.349-4.288L20.554,23.5h19.84L14.858,6.22 c-0.179,0.092-0.369,0.191-0.557,0.288C8.154,9.92,3.989,16.471,3.989,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.997,19.985c3.315,0,6.003-2.687,6.003-6.003c-0.527,1.341-1.482,2.451-2.697,3.175l-0.512-0.382 l1.005-0.753l-1.216-0.311l0.643-1.09l-1.256,0.181l0.186-1.246l-1.09,0.653l-0.311-1.231l-0.753,1.005l-0.753-1.005l-0.316,1.226 l-1.085-0.643l0.186,1.256l-1.256-0.186l0.653,1.09L11.2,16.032l1.005,0.753l-0.502,0.387c-1.19-0.703-2.16-1.788-2.702-3.175 C9,17.313,11.687,20,15.003,20L14.997,19.985z M12.308,29.308L9.804,29l1.519,2.009L9,32l2.322,0.981L9.803,34.99l2.505-0.308 L12,37.192l2.009-1.519L15,38l0.981-2.327L18,37.196l-0.308-2.505l2.505,0.313l-1.519-2.009L21,32.014l-2.322-0.991l1.519-2.009 l-2.505,0.304L18,26.813l-2.009,1.519L15,26l-0.981,2.322L12,26.804L12.308,29.308L12.308,29.308z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d47a1",
    d: "M35.5,22H17l18.124,18.613c0.837-0.562,1.616-1.201,2.357-1.88L24.108,25H35.5h8.439 c0.015-0.294,0.043-0.584,0.044-0.882l-6.802-4.603L16.446,5.483c-1.064,0.434-2.074,0.965-3.037,1.567L35.5,22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NepalCircular);
export default __webpack_public_path__ + "static/media/icons8-nepal-circular.fe8869105c8011d4b875626c32cebae4.svg";
export { ForwardRef as ReactComponent };